const PIXEL_ID = '2420809105336403';
interface Conversion { name: 'CompleteRegistration' | 'InitiateCheckout' | 'Purchase'; id: string; parameters: Record<string, string | number> }
const reported = new Set<string>();
const frames = new Set<HTMLIFrameElement>();
let generation = 0;
const allowed = (optedOut: () => boolean) => import.meta.env.MODE === 'production'
  && window.location.origin === 'https://userill.dev' && !optedOut()
  && !(navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl
  && !/(?:^|;\s*)rill_analytics_enabled=0(?:;|$)/.test(document.cookie)
  && new URLSearchParams(window.location.search).get('reddit_pixel_test') !== '1';
export function stopMetaConversions() {
  generation++;
  for (const frame of frames) frame.remove();
  frames.clear();
}
function send(event: Conversion, optedOut: () => boolean): Promise<void> {
  if (!allowed(optedOut) || reported.has(event.id)) return Promise.resolve();
  const key = `rill_meta_${event.id}`;
  try { if (localStorage.getItem(key)) return Promise.resolve(); } catch { /* In-memory deduplication remains available. */ }
  const current = generation;
  reported.add(event.id);
  return new Promise(resolve => {
    const frame = document.createElement('iframe');
    frame.hidden = true; frame.title = 'Meta conversion measurement';
    frame.setAttribute('sandbox', 'allow-scripts'); frame.referrerPolicy = 'no-referrer';
    const token = crypto.randomUUID();
    const data = JSON.stringify({ ...event, token }).replace(/</g, '\\u003c');
    // Opaque document has no access to parent DOM, URL, cookies, or storage.
    frame.srcdoc = `<meta name="referrer" content="no-referrer"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src 'unsafe-inline' https://connect.facebook.net; connect-src https://www.facebook.com https://*.facebook.com; img-src https://www.facebook.com https://*.facebook.com"><script>
const event=${data};
const fbq=window.fbq=function(){if(fbq.callMethod)fbq.callMethod.apply(fbq,arguments);else fbq.queue.push(arguments)};
window._fbq=fbq;fbq.push=fbq;fbq.loaded=true;fbq.version='2.0';fbq.queue=[];
fbq('set','autoConfig',false,'${PIXEL_ID}');fbq('init','${PIXEL_ID}');
const script=document.createElement('script');script.src='https://connect.facebook.net/en_US/fbevents.js';
script.onload=()=>{fbq('track',event.name,event.parameters,{eventID:event.id});parent.postMessage({type:'rill-meta-attempt',token:event.token},'*')};document.head.appendChild(script);
</script>`;
    const done = () => { clearTimeout(timeout); window.removeEventListener('message', onMessage); frame.remove(); frames.delete(frame); resolve(); };
    const onMessage = (message: MessageEvent) => {
      if (message.source !== frame.contentWindow || message.data?.token !== token || message.data?.type !== 'rill-meta-attempt') return;
      if (current !== generation || !allowed(optedOut)) { reported.delete(event.id); done(); return; }
      // Records SDK submission, not a Meta delivery receipt.
      try { localStorage.setItem(key, '1'); } catch { /* Optional persistence. */ }
      setTimeout(done, 200);
    };
    const timeout = setTimeout(() => { reported.delete(event.id); done(); }, 1500);
    window.addEventListener('message', onMessage);
    frames.add(frame); document.body.appendChild(frame);
  });
}
export async function startMetaConversions(optedOut: () => boolean) {
  const current = generation;
  if (!allowed(optedOut)) return;
  try {
    const response = await fetch('/api/advertising/meta', { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(3000) });
    if (!response.ok || current !== generation || !allowed(optedOut)) return;
    const config = await response.json() as { enabled?: boolean; events?: Conversion[] };
    if (!config.enabled || current !== generation || !allowed(optedOut)) return;
    await Promise.all((config.events ?? []).map(event => send(event, optedOut)));
  } catch { /* Measurement cannot block the app. */ }
}
export async function trackMetaCheckout(attemptId: string, optedOut: () => boolean) {
  if (!allowed(optedOut)) return;
  try { await send({ name: 'InitiateCheckout', id: `checkout_${attemptId}`, parameters: { content_name: 'Rill Pro' } }, optedOut); } catch { /* Checkout must continue. */ }
}
